module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-col-12"
  }, [_c('DataTable', {
    staticClass: "p-datatable-responsive p-datatable-gridlines",
    attrs: {
      "value": _vm.itemGroupLists,
      "paginator": true,
      "rows": 10,
      "data-key": "id"
    }
  }, [_c('Column', {
    attrs: {
      "header": "S.N",
      "headerStyle": "width: auto"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n        " + _vm._s(slotProps.index + 1) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Item Group",
      "field": "name",
      "filterField": "name",
      "filterMatchMode": "contains",
      "headerStyle": "width: 100%"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Action",
      "headerStyle": "width: auto"
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function() {
        return [_vm._v("No record found")]
      },
      proxy: true
    }, {
      key: "body",
      fn: function(slotProps) {
        return [_c('Button', {
          staticClass: "p-button-success p-button-sm",
          attrs: {
            "icon": "pi pi-pencil"
          },
          on: {
            "click": function($event) {
              return _vm.editItemGroup(slotProps.data)
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-danger p-button-sm",
          attrs: {
            "icon": "pi pi-trash"
          },
          on: {
            "click": function($event) {
              return _vm.openDialog(slotProps.data.id)
            }
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('Dialog', {
    on: {
      "cancel": _vm.cancel,
      "deleted": _vm.deleteItemGroup
    },
    model: {
      value: (_vm.dialogShow),
      callback: function($$v) {
        _vm.dialogShow = $$v
      },
      expression: "dialogShow"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e9ad0de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/item/itemgrouplist.vue
// module id = 2220
// module chunks = 0